import type { Address } from "viem"
import type { Config } from "wagmi"

import type { EmitEvent } from "@/domains/core"
import { EventEmitter } from "@/domains/library"
import { revoteMultiple } from "@/domains/on-chain"

interface ReVoteMultipleNftInteractionParams {
  account: Address
  chainId: number
  config: Config
  superVoterAddress: Address
  nftIds: Array<number>
  maxLock: boolean
  emitter: EventEmitter<EmitEvent>
}

export const revoteMultipleNftInteraction = async ({
  account,
  chainId,
  config,
  superVoterAddress,
  nftIds,
  emitter,
  maxLock,
}: ReVoteMultipleNftInteractionParams) => {
  const result = await revoteMultiple({
    account,
    chainId,
    config,
    superVoterAddress,
    nftIds,
    maxLock,
  })

  if (result.success) {
    emitter.emit("revote-multiple-nft", {
      title: "Re-Voted NFTs",
      description: `NFTs re-voted`,
      variant: "success",
    })
  }

  if (result.success === false) {
    emitter.emit("error-revoting", {
      title: "Re-Vote failed",
      description: `Unable to re-vote NFTs`,
      variant: "error",
    })
  }

  return result
}
